/**
 * Pick the singular or plural form of a word based on a count.
 *
 * Use sparingly — the goal is to replace inline `count === 1 ? 'word' : 'words'`
 * ternaries with one obvious helper. Don't reach for it on every string in the
 * app; reach for it when the alternative is a copy-pasted ternary or when the
 * word's irregular plural form risks a typo.
 *
 *   pluralise('attempt', 1)                → 'attempt'
 *   pluralise('attempt', 5)                → 'attempts'
 *   pluralise('strategy', 5, 'strategies') → 'strategies'   (irregular)
 *   pluralise('mismatch', 5, 'mismatches') → 'mismatches'   (irregular)
 *   pluralise('foot', 2, 'feet')           → 'feet'         (irregular)
 *
 * `count === 0` returns the plural form ("0 attempts" reads more naturally
 * than "0 attempt" in English).
 */
export function pluralise(singular: string, count: number, pluralForm?: string): string {
  return count === 1 ? singular : (pluralForm ?? `${singular}s`);
}
